import { createContext, useContext, useState } from 'react';

import { API_BASE_URL } from '../../config/baseURLs';
import EdenContext from '../edenContext';
import axiosInstance from '../../api/axiosInstance';

const FranchisedBrandsContext = createContext();

export const FranchisedBrandsProvider = ({ children }) => {
	const { crmAccCusSupp } = useContext(EdenContext);
	const [data, setData] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [error, setError] = useState(null);
	const [formValues, setFormValues] = useState({
		companyLogo: null,
		authorizationLetter: null,
		corpPresentation: null,
		sortDescription: '',
		longDescription: '',
		headquaters: null,
		categories: null,
		resources: [{ resourceName: null, resourceFile: null }],
	});

	const filterCRMAccount =
		Array.isArray(crmAccCusSupp) &&
		crmAccCusSupp?.filter(
			(el) => el?.INACTIVE !== 'Yes' && el?.ACCOUNT_TYPE === 'Supplier',
		);

	const filterUniqueIdsAndRecent = (arr) => {
		const uniqueIdsMap = new Map();

		arr?.forEach((obj) => {
			if (obj.ID) {
				const currentId = obj.id;
				const existingObj = uniqueIdsMap.get(currentId);

				if (
					!existingObj ||
					new Date(obj.updatedAt) > new Date(existingObj.updatedAt)
				) {
					uniqueIdsMap.set(currentId, obj);
				}
			}
		});

		return Array.from(uniqueIdsMap.values());
	};

	const getData = () => {
		setIsLoading(true);
		axiosInstance
			.get(`${API_BASE_URL}/franchised`)
			.then((response) => {
				setData(response.data?.data);
				setError(null);
			})
			.catch((err) => {
				setError(err);
				setData(null);
			})
			.finally(() => {
				setIsLoading(false);
			});
	};

	const extractFileName = (link) => {
		if (!link) return '';

		const file = link.split('/').pop();
		if (!file) return '';

		const parts = file.split('_');
		if (parts.length > 1) {
			return decodeURIComponent(parts.slice(1).join('_'));
		}

		return decodeURIComponent(file);
	};

	return (
		<FranchisedBrandsContext.Provider
			value={{
				getData,
				data,
				setData,
				isLoading,
				error,
				formValues,
				filterCRMAccount,
				setFormValues,
				extractFileName,
				filterUniqueIdsAndRecent,
			}}
		>
			{children}
		</FranchisedBrandsContext.Provider>
	);
};

export default FranchisedBrandsContext;
